import Image from 'next/image';

const DemoHeader = () => {
    return (
        <div className='max-w-[90%] h-[90px] lg:max-w-[1535px] lg:px-[50px] py-[20px] w-full grid justify-start items-center m-auto'>
            <div className="w-full">
                <Image
                    src="/images/logo.svg"
                    height={29}
                    width={189}
                    alt="Logo"
                    className="lg:h-[49px] h-[35px] lg:w-[146px] w-[100px] self-start justify-self-center mx-auto dark:hidden block"
                /> 
                <Image
                    src="/images/white-logo.svg"
                    height={29}
                    width={189}
                    alt="Logo"
                    className="lg:h-[30px] h-[20px] lg:w-[146px] w-[100px] self-start justify-self-center mx-auto dark:block hidden"
                />
            </div>
        </div>
    );
};

export default DemoHeader;